/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
import React from 'react';
import Header, { HeaderLeft } from '../layout/Header/Header';
import Navigation from '../layout/Navigation/Navigation';
import useDeviceScreen from '../hooks/useDeviceScreen';
import { demoPages } from '../menu';

const DefaultHeader = () => {
	const { width } = useDeviceScreen();
	return (
		<Header>
			<HeaderLeft>
				<Navigation
					menu={{  ...demoPages }}
					id='header-top-menu'
					horizontal={
						!!width && width >= Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
					}
				/>
			</HeaderLeft>
		</Header>
	);
};

export default DefaultHeader;
